import { FormStatus } from './entity';

/** Статусы могут использоваться в разных доменах данных ( список форм и другие )*/
export const STATUS_TEXTS: Record<FormStatus, string> = {
  [FormStatus.DRAFT]: 'Черновик',
  [FormStatus.FILE_UPLOAD]: 'Черновик',
  [FormStatus.VALIDATION]: 'Черновик',
  [FormStatus.PUBLISHED]: 'Опубликовано',
  [FormStatus.FINISHED]: 'Завершено',
};
